<script setup>
import WelcomeView from "@/components/common/WelcomeView";
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const isAuthenticated = computed(() => store.getters.isAuthenticated);
</script>

<template lang="html">

  <v-container v-if="!isAuthenticated">
    <v-card class="default-card">
      <WelcomeView />
    </v-card>
  </v-container>

</template>

<style scoped>
@import '@/assets/styles/views/HomeView.css';
</style>